import React from 'react'
import moment from 'moment'
import _ from 'underscore'

import './styles/instrument_editor.css'

export default class InstrumentEditor extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      instrument: undefined,
      saveMessage: undefined
    };
    // websocket connectionschrom
    this.sockets = [];
  }

  componentDidMount() {
    let self = this

    $(this.refs.txtInstrumentSearch).kendoAutoComplete({
      dataTextField: "description",
      template: '<span class="btn btn-xs btn-default" title="#= instrument_id #">#= product_type #</span> #= description #, <i>#= symbol #</i>',
      placeholder: "Search by symbol or description ...",
      filter: "contains",
      minLength: 2,
      dataSource: {
        serverFiltering: true,
        transport: {
          read: function (opts) {
            var searchTerm = opts.data.filter.filters[0].value
            api('/instrument/search?term=' + escape(searchTerm))
              .then((res) => {
                opts.success(res)
              }).catch((e) => { opts.error(e) })
          }
        }
      },
      select: function (e) {
        var item = this.dataItem(e.item.index())
        self.setState({
          instrument: undefined
        })
        api('/instruments/' + item.instrument_id)
          .then((res) => {
            self.checkStructure(res);
            self.setState({
              instrument: res,
              saveMessage: undefined
            })
          })
      }
    })
  }

  handleSymbolChange(event) {
    this.state.instrument.definition.ric = event.target.value;
    this.setState({ instrument: this.state.instrument })
  }

  handleDescriptionChange(event) {
    this.state.instrument.description = event.target.value;
    this.setState({ instrument: this.state.instrument })
  }

  handleProductTypeChange(event) {
    this.state.instrument.product_type = event.target.value;
    this.setState({ instrument: this.state.instrument })
  }

  handleCurrencyChange(event) {
    this.state.instrument.ccy = event.target.value;
    this.setState({ instrument: this.state.instrument })
  }

  handlePriceDivisorChange(event) {
    this.state.instrument.price_divisor = event.target.value;
    this.setState({ instrument: this.state.instrument })
  }

  handleExternalIdChange(event) {
    this.state.instrument.external_id = event.target.value;
    this.setState({ instrument: this.state.instrument })
  }

  handlePriceSourceSourceChange(ps, event) {
    ps.exchange = event.target.value;
    this.setState({ instrument: this.state.instrument })
  }

  handlePriceSourceSymbolChange(ps, event) {
    ps.symbol = event.target.value;
    this.setState({ instrument: this.state.instrument })
  }

  saveInstrument() {
    var instrumentToSave = JSON.parse(JSON.stringify(this.state.instrument));
    instrumentToSave.price_divisor = parseFloat(instrumentToSave.price_divisor);
    this.checkStructure(instrumentToSave);

    api('/instruments/' + instrumentToSave.instrument_id, {
      method: 'PUT',
      body: JSON.stringify(instrumentToSave)
    })
      .then((res) => {
        api('/instruments/' + instrumentToSave.instrument_id)
          .then(res => {
            this.checkStructure(res);
            this.setState({
              instrument: res
            })
            this.setState({ saveMessage: "Saved" });
          });
      })
      .catch(e => {
        this.setState({ saveMessage: e.message });
      })
  }

  checkStructure(instrument) {
    if (!instrument.definition) {
      instrument.definition = {}
    }
    if (!instrument.definition.price_sources) {
      instrument.definition.price_sources = []
    }
    // Add an empty price source form to teh instrument editor for each price_source
    // that we currently support.  TODO - move list of valid price sources to the database
    // so we can refactor this code.
    if (instrument.definition.price_sources.filter(ps => ps.price_source_type == "ice_data_services").length == 0) {
      instrument.definition.price_sources.push({
        price_source_type: "ice_data_services",
        exchange: "",
        symbol: ""
      })
    }
    if (instrument.definition.price_sources.filter(ps => ps.price_source_type == "yahoo").length == 0) {
      instrument.definition.price_sources.push({
        price_source_type: "yahoo",
        exchange: "",
        symbol: ""
      })
    }
  }

  componentWillUnmount() {
    for (var i = 0; i < this.sockets.length; i++) {
      this.sockets[i].close();
    };
    delete this.sockets;
  }

  render() {
    return (
      <div className="row" style={{ marginTop: "2em" }}>
        <div className="col-xs-offset-1 col-xs-10">
          <div className="row" style={{ marginBottom: "1em" }}>
            <input ref="txtInstrumentSearch" style={{ width: 300 }}></input>
          </div>
          {
            (this.state.instrument) ? (
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="control">
                      <div className="label">Symbol</div>
                      <input style={{ width: 300 }} className="k-input" type="text" value={this.state.instrument.definition.ric} onChange={(e) => this.handleSymbolChange(e)} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="control">
                      <div className="label">Description</div>
                      <input style={{ width: 300 }} className="k-input" type="text" value={this.state.instrument.description} onChange={(e) => this.handleDescriptionChange(e)} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="control">
                      <div className="label">Product Type</div>
                      <input style={{ width: 300 }} className="k-input" type="text" value={this.state.instrument.product_type} onChange={(e) => this.handleProductTypeChange(e)} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="control">
                      <div className="label">Currency</div>
                      <input style={{ width: 300 }} className="k-input" type="text" value={this.state.instrument.ccy} onChange={(e) => this.handleCurrencyChange(e)} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="control">
                      <div className="label">Price Divisor</div>
                      <input style={{ width: 300 }} className="k-input" type="text" value={this.state.instrument.price_divisor} onChange={(e) => this.handlePriceDivisorChange(e)} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="control">
                      <div className="label">External Reference</div>
                      <input style={{ width: 300 }} className="k-input" type="text" value={this.state.instrument.external_id} onChange={(e) => this.handleExternalIdChange(e)} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div>
                    <span className="area-header">Pricing Sources</span>
                    <table className="table table-bordered table-striped" style={{ width: '10em' }}>
                      <thead>
                        <tr>
                          <th>name</th>
                          <th>source</th>
                          <th>symbol</th>
                        </tr>
                      </thead>
                      <tbody>{
                        _.map(_.sortBy(this.state.instrument.definition.price_sources, (price_source) => price_source.price_source_type), (price_source) => {
                          return <tr key={price_source.price_source_type} className="clickable">
                            <td>{price_source.price_source_type}</td>
                            <td><input className="k-input" type="text" value={price_source.exchange} onChange={(e) => this.handlePriceSourceSourceChange(price_source, e)} /></td>
                            <td><input className="k-input" type="text" value={price_source.symbol} onChange={(e) => this.handlePriceSourceSymbolChange(price_source, e)} /></td>
                          </tr>
                        })
                      }</tbody>
                    </table>
                  </div>
                  <div>
                    <button className="save" onClick={() => { this.saveInstrument() }} style={{ width: '4em', padding: '.5em .1em', marginRight: '0.3em' }}>Save</button>
                    <div>{this.state.saveMessage}</div>
                  </div>
                </div>
              </div>
            ) : undefined
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/instrument_editor.jsx